<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title" style="text-align: center;">Business Details</h4>
    </div>
    <div class="card-content">
      <form>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Business Name</label>
              <input type="text"
                    name="businessName"
                    class="form-control border-input"
                    placeholder="Business Name"
                    v-model="authDetails.account.data.businessName"
                    v-validate="modelValidations.businessName">
              <small class="text-danger" v-show="businessName.invalid">
                {{ getError('businessName') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Country</label>
              <input type="text"
                    name="country"
                    class="form-control border-input"
                    placeholder="Country"
                    v-model="authDetails.account.data.country"
                    v-validate="modelValidations.country">
              <small class="text-danger" v-show="country.invalid">
                {{ getError('country') }}
              </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Address Line 1</label>
              <input type="text"
                    name="address"
                    class="form-control border-input"
                    placeholder="Address Line 1"
                    v-model="authDetails.account.data.address"
                    v-validate="modelValidations.address">
              <small class="text-danger" v-show="address.invalid">
                {{ getError('address') }}
              </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Address Line 2</label>
              <input type="text"
                    name="address2"
                    class="form-control border-input"
                    placeholder="Address Line 2"
                    v-model="authDetails.account.data.address2"
                    v-validate="modelValidations.address2">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>City</label>
              <input type="text"
                    name="city"
                    class="form-control border-input"
                    placeholder="City"
                    v-model="authDetails.account.data.city"
                    v-validate="modelValidations.city">
              <small class="text-danger" v-show="city.invalid">
                {{ getError('city') }}
              </small>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>State</label>
              <input type="text"
                    name="state"
                    class="form-control border-input"
                    placeholder="State"
                    v-model="authDetails.account.data.state"
                    v-validate="modelValidations.state">
              <small class="text-danger" v-show="state.invalid">
                {{ getError('state') }}
              </small>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Postal Code</label>
              <input type="text"
                    name="postalCode"
                    class="form-control border-input"
                    placeholder="ZIP Code"
                    v-model="authDetails.account.data.postalCode"
                    v-validate="modelValidations.postalCode">
              <small class="text-danger" v-show="postalCode.invalid">
                {{ getError('postalCode') }}
              </small>
            </div>
          </div>
        </div>
        
        <div class="text-center">
          <button v-if="!loading" type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="submit">
            Save
          </button>
          <button v-if="loading" type="submit" class="btn btn-info btn-fill btn-wd" disabled="disabled">
            <span class="btn-label">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
            Save
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import {mapFields} from 'vee-validate'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'

  export default {
    props: {
      authDetails: {
        type: Object,
        required: true
      }
    },
    mixins: [toolboxMixin],
    computed: {
      ...mapFields(['businessName',
        'address',
        'address2',
        'city',
        'state',
        'postalCode',
        'country'])
    },
    data () {
      return {
        modelValidations: {
          businessName: {
            required: true
          },
          address: {
            required: true
          },
          city: {
            required: true
          },
          state: {
            required: true
          },
          postalCode: {
            required: true,
            numeric: true
          },
          country: {
            required: true
          }
        },
        loading: false
      }
    },
    methods: {
      updateBusiness () {
        db.collection('accounts').doc(this.authDetails.account.id).update(this.authDetails.account.data).then(() => {
          this.showNotify('Businesss information saved.', 'success', 'Success')
          this.loading = false
        })
        .catch(error => {
          this.showNotify(error, 'danger', 'Failed')
          this.loading = false
        })
      },
      submit () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.updateBusiness()
          } else {
            this.loading = false
          }
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/partials/EditCompanyForm.vue